// ✅ Taiwan 時區處理工具
export const DateHelper = {
  /**
   * 將 UTC 或 ISO 格式時間字串轉為台灣時間並格式化
   * @param {string | Date} dateTime - UTC/ISO 時間字串或 Date 物件
   * @param {boolean} withTime - 是否顯示時分秒 (預設 true)
   * @returns {string} 例如 "2025/10/22 17:45:20"
   */
  toTaiwanFormat(dateTime, withTime = true) {
    if (!dateTime) return "未提供"; // ✅ 沒資料時顯示預設文字

    // 確保是 Date 物件
    const date = dateTime instanceof Date ? dateTime : new Date(dateTime);

    // 轉換為台灣時區時間 (UTC+8)
    const taiwanDate = new Date(date.getTime() + 8 * 60 * 60 * 1000); // ✅ 加 8 小時

    // 格式化為 yyyy/MM/dd HH:mm:ss
    const year = taiwanDate.getUTCFullYear();
    const month = String(taiwanDate.getUTCMonth() + 1).padStart(2, "0");
    const day = String(taiwanDate.getUTCDate()).padStart(2, "0");

    if (!withTime) return `${year}/${month}/${day}`;

    const hours = String(taiwanDate.getUTCHours()).padStart(2, "0");
    const minutes = String(taiwanDate.getUTCMinutes()).padStart(2, "0");
    const seconds = String(taiwanDate.getUTCSeconds()).padStart(2, "0");

    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  },

  /**
   * 取得目前台灣時間（Date 物件）
   * @returns {Date}
   */
  nowInTaiwan() {
    const now = new Date();
    return new Date(now.getTime() + 8 * 60 * 60 * 1000); // ✅ +8 小時
  },
};
